import newPasswordComponent from './new-password.component';

const newPasswordModule = angular.module('newPassword', [
])
  .component('newPassword', newPasswordComponent)
  .name;

export default newPasswordModule;
